import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { DISPLAY_DATE } from "constants/date";
import { Field, FieldProps, useFormikContext } from "formik";
import { useState } from "react";
import { useWindowSize } from "hooks/useWindowSize";
import { MultiValue, SingleValue } from "react-select";

export const DueDate = ({
  minDate,
  required,
  dueDate,
  options,
  name,
  label = "Due date",
  disabled = false,
  isLoading = false,
  size = "small",
}: {
  minDate?: string | null;
  required?: boolean;
  dueDate?: string | null;
  options: OptionData[];
  name: string;
  label?: string;
  disabled?: boolean;
  isLoading?: boolean;
  size?: "small" | "regular";
}) => {
  const { setFieldValue } = useFormikContext();
  const { isMobile } = useWindowSize();
  const [selectingDate, setSelectingDate] = useState(false);

  const handleChange = (
    newValue: SingleValue<OptionData> | MultiValue<OptionData>
  ) => {
    if (newValue) {
      const value = (newValue as OptionData).value;
      if (value === "CUSTOM") {
        setSelectingDate(true);
        return;
      }
      setFieldValue(name, value);
    }
  };

  const currentValue = dueDate
    ? options.find((option) => option.value === dueDate) || options.at(-1)
    : null;

  if (selectingDate) {
    return (
      <Field name={name} placeholder="Select a due date" required={required}>
        {({ field }: FieldProps) => {
          return (
            <DateInput
              customSize={size}
              portalId={field.name}
              popperPlacement={isMobile ? "bottom-end" : undefined}
              open={selectingDate}
              onClickOutside={() => {
                setSelectingDate(false);
              }}
              {...field}
              onDateChange={() => {
                setSelectingDate(false);
              }}
              customDatePickerInputTrigger={
                <Combobox
                  onChange={handleChange}
                  label={label}
                  isClearable={false}
                  options={options}
                  required={required}
                  isSearchable={false}
                  value={currentValue}
                  placeholder={DISPLAY_DATE}
                  size={size}
                />
              }
              label={label}
              placeholder={DISPLAY_DATE}
              required={required}
              disabled={disabled}
              minDate={minDate ? new Date(minDate) : undefined}
            />
          );
        }}
      </Field>
    );
  }

  return (
    <Combobox
      onChange={handleChange}
      label={label}
      isClearable={false}
      options={options}
      required={required}
      isSearchable={false}
      value={currentValue}
      isLoading={isLoading}
      isDisabled={disabled}
      placeholder={DISPLAY_DATE}
      menuPortalTarget={document.body}
      size={size}
    />
  );
};
